export default "__VITE_ASSET__k065cW2k__"